// copy booking box on mobile to the #bb wrapper
// detect when it's out of view
// detect whether it's above or below the view

class BookingBox {

	constructor( el ){
		this.mediaQuery = '(max-width: 767px)';
		this.target = document.querySelector(el);
		this.src = document.querySelector('.booking-box');
		this.button = document.querySelector('.booking-box-button');

		if( this.isMobile() ){
			this.setup();
		}
		
	}

	setup() {
		// Create clone of booking box to new area on mobile

		if(!this.src){
			return;
		}

		const clone = this.src.cloneNode(true);
		this.target.appendChild(clone);

		// Check whether it's in view
		const body = document.querySelector('body');
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const cls = ['bb-above','bb-below']
					body.classList.add('bb-inview');
					body.classList.remove(...cls);
				} else {
					body.classList.remove('bb-inview');
					const above = entry.boundingClientRect.top < 0;
					const below = entry.boundingClientRect.top > window.innerHeight;
					if (above) {
						body.classList.remove('bb-below');
						body.classList.add('bb-above');
					} else if (below) {
						body.classList.add('bb-below');
						body.classList.remove('bb-above');
					}
			  	}
			});
		  }, { threshold: 0.75 });
		  
		observer.observe(this.target);

	}

	isMobile() {
		const mq = window.matchMedia(this.mediaQuery);
		mq.addEventListener('change', (e) => {
			return mq.matches;
		});
		return mq.matches;
	}

	destroy() {
		this.target.innerHTML = '';
		return;
	}

}


export default BookingBox